import { AxiosInstance } from 'axios'

import { CustomerAccount } from '../../../domain'
import { withGenericErrorHandling } from '../errors'

export interface CustomerAccountClient {
  createCustomerAccount: (proposalCode: string) => Promise<CustomerAccount>
  getCustomerAccounts: (params?: { policyNumber?: string }) => Promise<CustomerAccount[]>
  updatePaymentDay: (
    accountId: string,
    request: UpdatePaymentDayRequest,
  ) => Promise<CustomerAccount>
}

export interface UpdatePaymentDayRequest {
  policyId: string
  paymentDay: number
}

export const createCustomerAccountClient = (
  getInstance: () => Promise<AxiosInstance>,
): CustomerAccountClient => ({
  getCustomerAccounts: (params) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.get<CustomerAccount[]>(`/customerAccounts`, {
        params,
      })
      return response.data
    }),

  createCustomerAccount: (proposalCode) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.post<CustomerAccount>(`/customerAccounts`, {
        proposalCode,
      })
      return response.data
    }),

  updatePaymentDay: (accountId, request) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.put<CustomerAccount>(
        `/customerAccounts/${accountId}/paymentDay`,
        request,
      )
      return response.data
    }),
})
